/**
 * @file Defines trace parser functionality.
 * @internal
 * @copyright 2016 Microsoft Corporation
 */

(function (_traceParser) {
    "use strict";

    Globalize.addCultureInfo("en", {
        messages: {
            TraceParser_Aggregate: "Aggregate",
            TraceParser_NonAggregate: "Non-aggregate",
            TraceParser_AvgDbCalls: "Average Database Calls",
            TraceParser_BindTime: "Bind Time(ms)",
            TraceParser_CallStack: "Call Stack",
            TraceParser_Caption: "Trace Parser",
            TraceParser_ChangeSession: "Get Session Data",
            TraceParser_Count: "Count",
            TraceParser_CreateSubTrace: "Create subtrace",
            TraceParser_Db: "Database",
            TraceParser_DbMs: "Database Milliseconds",
            TraceParser_ExcAvg: "Exclusive Average",
            TraceParser_ExcMs: "Exclusive",
            TraceParser_ExcTotal: "Exclusive Total",
            TraceParser_Exit: "Close",
            TraceParser_ID: "TraceId",
            TraceParser_ImportTrace: "Import Trace",
            TraceParser_IncAvg: "Inclusive Average",
            TraceParser_IncMs: "Inclusive",
            TraceParser_IncTotal: "Inclusive Total",
            TraceParser_Intro: "Your performance tool for AX",
            TraceParser_Launch: "Display",
            TraceParser_Name: "Name",
            TraceParser_Open: "Open trace parser",
            TraceParser_OpenTrace: "Open Trace",
            TraceParser_Options: "Options",
            TraceParser_PrepTime: "Prep Time(ms)",
            TraceParser_RowFetchTime: "Row Fetch Total(ms)",
            TraceParser_RowFetchTot: "Row Fetch Total",
            TraceParser_RowFetchTotal: "Row Fetch Total",
            TraceParser_SelectTrace: "Select Trace",
            TraceParser_SelectTraceSession: "Select Customer-User-Session",
            TraceParser_Seq: "Sequence",
            TraceParser_Sequence: "Sequence",
            TraceParser_SessionProps: "Trace session properties",
            TraceParser_SourceCode: "Source Code",
            TraceParser_ImportTraceButton: "Import Trace",
            TraceParser_StartButton: "Start",
            TraceParser_StartTrace: "Start Trace",
            TraceParser_StopButton: "Stop",
            TraceParser_StopTrace: "Stop Trace",
            TraceParser_SubmitButton: "Submit",
            TraceParser_TabTraceSummary: "TraceSummary",
            TraceParser_TabCallTree: "CallTree",
            TraceParser_TabSql: "SQL",
            TraceParser_TabXpp: "X++",
            TraceParser_ToggleLines: "Lines",
            TraceParser_ToggleTables: "Tables",
            TraceParser_TotDbCalls: "Total Database Calls",
            TraceParser_TotExecTime: "Total Execution Time",
            TraceParser_TotRowsFetched: "Total Rows Fetched",
            TraceParser_TreeBorder: "Toggle Border",
            TraceParser_TreeCheckBoxes: "Toggle Checkboxes",
            TraceParser_TraceFileName: "Trace FileName",
            TraceParser_TraceSessionSummary: "Trace Sessions",
            TraceParser_TraceStartTime: "Trace Start Time",
            TraceParser_TraceEndTime: "Trace End Time"
        }
    });

    _traceParser.TraceParserForm = function () {
        var self = this;
        self.FormCaption = "Trace Analyzer";
        //constants
        var subTabNameXppAgg = "XppAgg";
        var subTabNameXppAll = "XppAll";
        var subTabNameSqlLinesAgg = "sqlAggLinesFull";
        var subTabNameSqlLinesAll = "SQLLinesAll";
        var subTabNameSqlTablesAgg = "sqlAggTablesFull";
        var subTabNameSqlTablesAll = "SQLTablesAll";
        var msgTraceParserErrorTraceNotFound = "This trace was not found in the trace store";
        var msgTraceParserErrorSessionsNotFound = "This trace didn't have any sessions to analyze";
        var msgCantCreateSubtrace = "Can't create subtrace for this node.";
        var msgGenericError = "Error occured. Please reopen the trace.";

        self.Text = $dyn.observable("");
        self.FormName = $dyn.observable("");
        self.FormUniqueId = $dyn.observable("");
        self.ActiveItemName = $dyn.observable($dyn.label("TraceParser_TabXpp"));

        // Observables
        self.createSubTraceVisible = $dyn.observable(false);
        self.inputFilterVal = $dyn.observable("");
        self.sqlSelectedField = $dyn.observable("");
        self.xppSelectedField = $dyn.observable("");
        self.selectedDataGridId = $dyn.observable(-1);
        self.selectedCallStackIndex = $dyn.observable(-1);
        self.selectedTraceGridIndex = $dyn.observable();
        self.selectedTraceId = $dyn.observable(0);
        self.multipleCallStacks = $dyn.observable(false);
        self.currentCallStackIndex = $dyn.observable(0);
        self.stackTraceCount = $dyn.observable(0);
        self.totalInclusive = $dyn.observable(0);
        self.callStackIndexDescription = $dyn.observable();
        self.pageRowCount = $dyn.observable(0);
        self.currentCallStackArrayVisual = $dyn.observableArray();
        self.currentSourceCode = $dyn.observable(null);
        self.CanLaunch = $dyn.observable(false);
        self.showXppAgg = $dyn.observable(true);
        self.sqlMode = $dyn.observable(false);
        self.sqlAvg = $dyn.observable(true);
        self.currentPageIndex = $dyn.observable(1);
        self.selectedTraceSessionXppInclusiveDuration = $dyn.observable(0);
        self.selectedTraceSessionXppExclusiveDuration = $dyn.observable(0);
        self.selectedTraceSessionDatabaseDuration = $dyn.observable(0);
        self.selectedTraceSessionTotalDuration = $dyn.observable(0);
        self.selectedTraceSession = $dyn.observable(-1);
        self.traceSessions = $dyn.observableArray();
        self.showTracesPane = $dyn.observable(false);
        self.showTraceSessionsPane = $dyn.observable(false);
        self.showTracesPane = $dyn.observable(false);
        self.traceParserCallStackExpanded = $dyn.observable(false);

        //Local variables
        var sessionData = [];
        var traces = [];
        var emptyString = "";

        //Default page size is defaulted to 22 based on our generic row size and 100% default view size on chrome.
        //Set pagesize to be 25 which is same with grid.js and will keep using 25 if there is a confict in the branch integration
        self.defaultPageSize = 25;
        self.currentSqlLineAllIndex = $dyn.observable(-1);
        self.currentSqlLineAggIndex = $dyn.observable(-1);
        self.currentSqlTableAllIndex = $dyn.observable(-1);
        self.currentSqlTableAggIndex = $dyn.observable(-1);
        self.currentXppAggIndex = $dyn.observable(-1);
        self.currentXppAllIndex = $dyn.observable(-1);
        var callStackItemsCount = 0;
        var allCallStacks = new Array(new Array);
        var allCallStacksInfo = [];

        self.fieldList = ["Name"];
        self.xppAggDataFull = $dyn.observableArray();
        self.sqlAllLinesDataFull = $dyn.observableArray();
        self.sqlAllTablesDataFull = $dyn.observableArray();
        self.sqlAggLinesFull = $dyn.observableArray();
        self.sqlAggTablesFull = $dyn.observableArray();
        self.xppAllDataFull = $dyn.observableArray();
        self.sqlAllLinesDataBuffered = $dyn.observableArray();
        self.sqlAllTablesDataBuffered = $dyn.observableArray();
        self.sqlAggLinesDataBuffered = $dyn.observableArray();
        self.sqlAggTablesDataBuffered = $dyn.observableArray();
        self.xppAggDataBuffered = $dyn.observableArray();
        self.xppAllDataBuffered = $dyn.observableArray();
        self.allTraces = $dyn.observableArray();
        self.aggregateButtonXppLabel = $dyn.observable($dyn.label("TraceParser_NonAggregate"));
        self.aggregateButtonSqlLabel = $dyn.observable($dyn.label("TraceParser_NonAggregate"));
        self.tablesLinesButtonLabel = $dyn.observable($dyn.label("TraceParser_ToggleTables"));

        //Navigation methods
        self.NavigateToTab = function (tabName) {
            if (tabName != undefined) {
                self.ActiveItemName(tabName);
            }
        };

        var callStackAdded = false;

        //Start by hiding the call stack
        $("#TraceParserCallStack").hide();
        self.traceParserCallStackExpanded.valueChanged.subscribe(function () {
            if (!callStackAdded) {
                //User opened the call stack section, append the callstack group
                $("#CallStackParent").append($("#TraceParserCallStack"));
                callStackAdded = true;
            }

            if (self.traceParserCallStackExpanded()) {
                $("#TraceParserCallStack").show();
            } else {
                $("#TraceParserCallStack").hide();
            }

        });

        //Start with hiding the Traces and the TraceSessionsList

        self.showTraces = function () {
            if (self.showTracesPane()) {
                self.showTracesPane(false);
            } else {
                if (self.showTraceSessionsPane()) {
                    self.showTraceSessionsPane(false);
                }

                self.showTracesPane(true);
            }
        };
        self.showTraceSessions = function () {
            if (self.showTraceSessionsPane()) {
                self.showTraceSessionsPane(false);
            } else {
                if (self.showTracesPane()) {
                    self.showTracesPane(false);
                }

                self.showTraceSessionsPane(true);
            }
        };
        self.showSummaryPane = $dyn.computed(function () {
            return self.showTracesPane() || self.showTraceSessionsPane();
        });

        //State change methods
        self.selectedDataGridId.valueChanged.subscribe(function () {
            self.getCallStack();
        });

        self.selectedCallStackIndex.valueChanged.subscribe(function () {
            self.updateSouceCode();
        });

        $("#treeGrid").on("rowSelect", function () {
            var selection = $("#treeGrid").jqxTreeGrid("getSelection");
            self.getCallStack(selection);
        });

        self.selectedTraceSession.valueChanged.subscribe(function () {
            self.getData();
            if (self.traceSessions().length > self.selectedTraceSession()) {
                self.selectedTraceSessionXppInclusiveDuration(self.traceSessions()[self.selectedTraceSession()].XppAggregateInclusiveDuration);
                self.selectedTraceSessionXppExclusiveDuration(self.traceSessions()[self.selectedTraceSession()].XppAggregateExclusiveDuration);
                self.selectedTraceSessionDatabaseDuration(self.traceSessions()[self.selectedTraceSession()].SqlAggregateTime);
                self.selectedTraceSessionTotalDuration(self.traceSessions()[self.selectedTraceSession()].Duration);
            }
        });


        self.ServerVal = $dyn.observable("");

        self.changeTableLineSelection = function (arg) {
            self.sqlMode(arg);
        };
        self.changeAverageDetailSelection = function (arg) {
            self.sqlAvg(arg);
        };

        self.importSelectedTrace = function () {
            if (self.allTraces != null) {
                var currentTrcId = self.allTraces()[self.selectedTraceGridIndex()];
                if (currentTrcId != null) {
                    self.selectedTraceId(currentTrcId.TraceId);
                    self.openTrace();
                }
            }
        };

        self.Expanded = $dyn.computed(function () {
            var value = $dyn.value(self.FrameOptionValue);
            var frameOptionButtonType = $dyn.value(self.FrameOptionButton);

            return frameOptionButtonType !== "Hide" || (value === 1 || value === "1");
        });

        self.Close = function () {
            var context = $dyn.context(element);
            $dyn.applyFunction(context.Close, context);
        };

        self.flipXppAgg = function () {
            var currentObservable = self.Utils.GetActiveFormObservableBuffered();
            var selection = currentObservable()[self.selectedDataGridId()];
            if (selection && selection.Name) {
                self.inputFilterVal(selection.Name);
                self.applyFilterValue();
            }
            if (self.showXppAgg()) {
                self.showXppAgg(false);
            } else {
                self.showXppAgg(true);
            }
        };
        self.flipSqlAgg = function () {
            var currentObservable = self.Utils.GetActiveFormObservableBuffered();
            var selection = currentObservable()[self.selectedDataGridId()];
            if (selection && selection.Name) {
                self.inputFilterVal(selection.Name);
                self.applyFilterValue();
            }
            if (self.sqlAvg()) {
                self.sqlAvg(false);
            } else {
                self.sqlAvg(true);
            }
        };
        self.aggregateButtonXppLabel = $dyn.computed(function () {
            if (self.showXppAgg()) {
                return $dyn.label("TraceParser_NonAggregate");
            } else {
                return $dyn.label("TraceParser_Aggregate");
            }
        });

        self.aggregateButtonSqlLabel = $dyn.computed(function () {
            if (self.sqlAvg()) {
                return $dyn.label("TraceParser_NonAggregate");
            } else {
                return $dyn.label("TraceParser_Aggregate");
            }
        });
        self.flipSqlView = function () {

            //Clear the Filter because the table view and lines view don't have any comman content.
            self.inputFilterVal("");
            self.applyFilterValue();
            if (self.sqlMode()) {
                self.sqlMode(false);
                self.tablesLinesButtonLabel($dyn.label("TraceParser_ToggleTables"));
            } else {
                self.sqlMode(true);
                self.tablesLinesButtonLabel($dyn.label("TraceParser_ToggleLines"));
            }
        };
        self.ShowXpp = $dyn.computed(function () {
            return !self.showXppAgg();
        });
        self.ShowStartTrace = $dyn.observable(true);
        self.ShowStopTrace = $dyn.computed(function () {
            return !self.ShowStartTrace();
        });

        self.showSqlLinesAgg = $dyn.computed(function () {
            return !self.sqlMode() && self.sqlAvg();
        });

        self.showSqlTablesAgg = $dyn.computed(function () {
            return self.sqlMode() && self.sqlAvg();
        });

        self.ShowSqlLines = $dyn.computed(function () {
            return !self.sqlMode() && !self.sqlAvg();
        });

        self.ShowSqlTables = $dyn.computed(function () {
            return self.sqlMode() && !self.sqlAvg();
        });

        self.ShowSql = $dyn.computed(function () {
            return !self.sqlAvg();
        });

        self.Utils = {
            GetActiveFormObservable: function () {
                switch (self.Utils.GetCurrentSubTabName()) {
                    case subTabNameSqlLinesAgg:
                        return self.sqlAggLinesFull;
                    case subTabNameSqlLinesAll:
                        return self.sqlAllLinesDataFull;
                    case subTabNameSqlTablesAgg:
                        return self.sqlAggTablesFull;
                    case subTabNameSqlTablesAll:
                        return self.sqlAllTablesDataFull;
                    case subTabNameXppAgg:
                        return self.xppAggDataFull;
                    case subTabNameXppAll:
                        return self.xppAllDataFull;
                }

                return $dyn.observableArray();
            },

            GetActiveFormIndex: function () {
                switch (self.Utils.GetCurrentSubTabName()) {
                    case subTabNameSqlLinesAgg:
                        return self.currentSqlLineAggIndex;
                    case subTabNameSqlLinesAll:
                        return self.currentSqlLineAllIndex;
                    case subTabNameSqlTablesAgg:
                        return self.currentSqlTableAggIndex;
                    case subTabNameSqlTablesAll:
                        return self.currentSqlTableAllIndex;
                    case subTabNameXppAgg:
                        return self.currentXppAggIndex;
                    case subTabNameXppAll:
                        return self.currentXppAllIndex;
                }

                return $dyn.observable(0);

            },

            GetActiveFormObservableBuffered: function () {
                switch (self.Utils.GetCurrentSubTabName()) {
                    case subTabNameSqlLinesAgg:
                        return self.sqlAggLinesDataBuffered;
                    case subTabNameSqlLinesAll:
                        return self.sqlAllLinesDataBuffered;
                    case subTabNameSqlTablesAgg:
                        return self.sqlAggTablesDataBuffered;
                    case subTabNameSqlTablesAll:
                        return self.sqlAllTablesDataBuffered;
                    case subTabNameXppAgg:
                        return self.xppAggDataBuffered;
                    case subTabNameXppAll:
                        return self.xppAllDataBuffered;
                }

                return 0;

            },

            GetCurrentSubTabName: function () {
                switch (self.ActiveItemName()) {
                    case $dyn.label("TraceParser_TabSql"):
                        {
                            if (self.ShowSqlLines()) {
                                return subTabNameSqlLinesAll;
                            } else if (self.ShowSqlTables()) {
                                return subTabNameSqlTablesAll;
                            } else if (self.showSqlLinesAgg()) {
                                return subTabNameSqlLinesAgg;
                            } else if (self.showSqlTablesAgg()) {
                                return subTabNameSqlTablesAgg;
                            }
                        }
                    case $dyn.label("TraceParser_TabXpp"):
                        {
                            if (self.showXppAgg()) {
                                return subTabNameXppAgg;
                            } else {
                                return subTabNameXppAll;
                            }
                        }
                }
                return undefined;
            },

            CallServer: function (args) {
                return $.ajax({
                    url: args.url,
                    type: args.type,
                    dataType: args.dataType,
                    statusCode: args.statusCode,
                    headers: args.headers,
                    cache: args.cache === undefined ? true : args.cache,
                    beforeSend: function () {
                        $dyn.shell.blockUserInteractionNoWait("Trace parser");
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("TraceParser");
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax();
                    },
                    complete: function () {
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                        $dyn.shell.unBlockUserInteraction();
                    }
                });
            }
        };

        self.getGenericFilter = function (args, callback) {
            if (args && args.length === 2) {
                var filterData = {
                    Values: new Array(""),
                    Operator: $dyn.controls.FilterField.Operators.is,
                    IsEditable: "No",
                    Capability: {
                        DisplayDataType: $dyn.controls.FilterField.DataTypes.String,
                        FieldId: 999999,
                        FieldLabel: "Test",
                        FieldName: "ID",
                        ShowLookup: false,
                        TableId: 0
                    },
                    DataSourceName: "TraceParser",
                    FieldName: "ID",
                    IsQueryFilter: "No",
                    MasterFormDataSourceName: "None",
                    RecordingReferences: new Array()
                };
                if (callback) {
                    callback(filterData);
                }
            }

        };
        self.getGenericSetSort = function (sort) {
            //Unfortunate use of hardcoded logic in Grid.js. use that to interpret what the sort object is
            //TODO: Change it
            /*
            var sort = [];
            sort.push($dyn.value(self.FormDataSourceName));
            sort.push($dyn.value(self.FieldName));
            var sortDirection;
            if (isAscending) {
                sort.push('1');
                sortDirection = 1;
            } else {
                sort.push('0');
                sortDirection = 0;
            }

            // set clear sorts to 1
            sort.push('1');
            if (sort) {
                
            }                                                                
            */
            if (sort && sort.length && sort.length === 4) {
                var localObservable;
                var viewModel = "";
                if (sort[0]) {
                    viewModel = sort[0];
                }
                switch (viewModel) {
                    case "allTraces":
                        localObservable = self.allTraces;
                        break;
                    case "xppAggDataFull":
                        localObservable = self.xppAggDataFull;
                        break;
                    case "sqlAllLinesDataFull":
                        localObservable = self.sqlAllLinesDataFull;
                        break;
                    case "sqlAllTablesDataFull":
                        localObservable = self.sqlAllTablesDataFull;
                        break;
                    case "sqlAggLinesDataFull":
                        localObservable = self.sqlAggLinesFull;
                        break;
                    case "sqlAggTablesDataFull":
                        localObservable = self.sqlAggTablesFull;
                        break;
                    case "xppAllDataFull":
                        localObservable = self.xppAllDataFull;
                        break;
                        //Add cases defined in traceparser.htm
                    default:
                        localObservable = $dyn.observableArray();
                        break;
                }

                var sortFieldName = "";
                if (sort[1]) {
                    sortFieldName = sort[1];
                }

                var sortOrder = "";
                if (sort[2]) {
                    sortOrder = sort[2];
                }

                if (localObservable() && localObservable()[0] && localObservable()[0].hasOwnProperty(sortFieldName)) {
                    localObservable.sort(function (greater, smaller) {
                        if (greater[sortFieldName] < smaller[sortFieldName]) {
                            //1 is ascending
                            if (sortOrder === 1) {
                                return -1;
                            } else {
                                return 1;
                            }
                        } else if (greater[sortFieldName] > smaller[sortFieldName]) {
                            if (sortOrder === 1) {
                                return 1;
                            } else {
                                return -1;
                            }
                        }

                        return 0;
                    });
                }
            }
        };
        self.getGenericResetFilters = function (args) {
            if (args && args.length === 2) {
                //TODO
            }
        };
        self.getGenericApplyFilter = function (args) {
            if (args) {
                //TODO
            }
        };
        self.applyFilterValue = function () {
            var filterval = self.inputFilterVal().toString().toLowerCase();
            var currentObservable = self.Utils.GetActiveFormObservable();
            var currentIndex = self.Utils.GetActiveFormIndex();
            var currentBufferedObservable = self.Utils.GetActiveFormObservableBuffered();
            if (filterval !== "") {
                currentBufferedObservable(currentObservable().filter(function (arrayValue) {
                    return arrayValue.Name.toLocaleLowerCase().indexOf(filterval) === 0;
                }
                    ));
            } else {
                currentIndex.valueChanged.raise(this, true);
            }
        };

        //Functions implementing client side paging. 


        self.sqlMode.valueChanged.subscribe(function () {
            self.updatePageAndRowCounts();
            self.applyFilterValue();
        });

        self.sqlAvg.valueChanged.subscribe(function () {
            self.updatePageAndRowCounts();
            self.applyFilterValue();
        });

        self.showXppAgg.valueChanged.subscribe(function () {
            self.updatePageAndRowCounts();
            self.applyFilterValue();
        });

        self.updatePageAndRowCounts = function () {
            self.currentPageIndex(self.updatePageIndex());
            self.pageRowCount(self.updateRowCount());
        };

        self.updateRowCount = function () {
            var observable = self.Utils.GetActiveFormObservable();
            return observable().length;
        };

        self.updatePageIndex = function () {
            var currentIndex = self.Utils.GetActiveFormIndex();
            return Math.ceil(currentIndex() / self.defaultPageSize) + 1;
        };

        self.maxPageIndex = $dyn.computed(function () {
            if (self.pageRowCount() > 0) {
                return Math.ceil(self.pageRowCount() / self.defaultPageSize);
            } else
                return 1;
        });

        self.xppAggDataFull.valueChanged.subscribe(function () {
            self.currentXppAggIndex(0, true);
        });

        self.sqlAggTablesFull.valueChanged.subscribe(function () {
            self.currentSqlTableAggIndex(0, true);
        });

        self.xppAllDataFull.valueChanged.subscribe(function () {
            self.currentXppAllIndex(0, true);
        });

        self.sqlAllLinesDataFull.valueChanged.subscribe(function () {
            self.currentSqlLineAllIndex(0, true);
        });

        self.sqlAllTablesDataFull.valueChanged.subscribe(function () {
            self.currentSqlTableAllIndex(0, true);
        });

        self.sqlAggLinesFull.valueChanged.subscribe(function () {
            self.currentSqlLineAggIndex(0, true);
        });

        self.currentXppAggIndex.valueChanged.subscribe(function () {
            self.xppAggDataBuffered(self.updateBufferedData(self.xppAggDataFull(), self.currentXppAggIndex()));
        });

        self.updateBufferedData = function (source, index) {
            var endIndex = Math.min(source.length, (index + self.defaultPageSize));
            return source.slice(index, endIndex);
        };

        self.currentSqlTableAggIndex.valueChanged.subscribe(function () {
            self.sqlAggTablesDataBuffered(self.updateBufferedData(self.sqlAggTablesFull(), self.currentSqlTableAggIndex()));
        });

        self.currentXppAllIndex.valueChanged.subscribe(function () {
            self.xppAllDataBuffered(self.updateBufferedData(self.xppAllDataFull(), self.currentXppAllIndex()));
        });

        self.currentSqlLineAllIndex.valueChanged.subscribe(function () {
            self.sqlAllLinesDataBuffered(self.updateBufferedData(self.sqlAllLinesDataFull(), self.currentSqlLineAllIndex()));
        });

        self.currentSqlTableAllIndex.valueChanged.subscribe(function () {
            self.sqlAllTablesDataBuffered(self.updateBufferedData(self.sqlAllTablesDataFull(), self.currentSqlTableAllIndex()));
        });

        self.currentSqlLineAggIndex.valueChanged.subscribe(function () {
            self.sqlAggLinesDataBuffered(self.updateBufferedData(self.sqlAggLinesFull(), self.currentSqlLineAggIndex()));
        });

        self.changePageSqlLinesAll = function (flag) {
            if (flag) {
                if (self.currentSqlLineAllIndex() < self.sqlAllLinesDataFull().length) {
                    self.currentSqlLineAllIndex(self.currentSqlLineAllIndex() + self.defaultPageSize);
                }
            } else {
                if (self.currentSqlLineAllIndex() >= self.defaultPageSize) {
                    self.currentSqlLineAllIndex(self.currentSqlLineAllIndex() - self.defaultPageSize);
                }
            }
        };

        self.changePageSqlLinesAgg = function (flag) {
            if (flag) {
                if (self.currentSqlLineAggIndex() < self.sqlAggLinesFull().length) {
                    self.currentSqlLineAggIndex(self.currentSqlLineAggIndex() + self.defaultPageSize);
                }
            } else {
                if (self.currentSqlLineAggIndex() >= self.defaultPageSize) {
                    self.currentSqlLineAggIndex(self.currentSqlLineAggIndex() - self.defaultPageSize);
                }
            }
        };

        self.changePageSqlTablesAll = function (flag) {
            if (flag) {
                if (self.currentSqlTableAllIndex() < self.sqlAllTablesDataFull().length) {
                    self.currentSqlTableAllIndex(self.currentSqlTableAllIndex() + self.defaultPageSize);
                }
            } else {
                if (self.currentSqlTableAllIndex() >= self.defaultPageSize) {
                    self.currentSqlTableAllIndex(self.currentSqlTableAllIndex() - self.defaultPageSize);
                }
            }
        };

        self.changePageSqlTablesAgg = function (flag) {
            if (flag) {
                if (self.currentSqlTableAggIndex() < self.sqlAggTablesFull().length) {
                    self.currentSqlTableAggIndex(self.currentSqlTableAggIndex() + self.defaultPageSize);
                }
            } else {
                if (self.currentSqlTableAggIndex() >= self.defaultPageSize) {
                    self.currentSqlTableAggIndex(self.currentSqlTableAggIndex() - self.defaultPageSize);
                }
            }
        };

        self.changePageXppAgg = function (flag) {
            if (flag) {
                if (self.currentXppAggIndex() < self.xppAggDataFull().length) {
                    self.currentXppAggIndex(self.currentXppAggIndex() + self.defaultPageSize);
                }
            } else {
                if (self.currentXppAggIndex() >= self.defaultPageSize) {
                    self.currentXppAggIndex(self.currentXppAggIndex() - self.defaultPageSize);
                }
            }
        };

        self.changePageXppAll = function (flag) {
            if (flag) {
                if (self.currentXppAllIndex() < self.xppAllDataFull().length) {
                    self.currentXppAllIndex(self.currentXppAllIndex() + self.defaultPageSize);
                }
            } else {
                if (self.currentXppAllIndex() >= self.defaultPageSize) {
                    self.currentXppAllIndex(self.currentXppAllIndex() - self.defaultPageSize);
                }
            }
        };

        self.changePage = function (flag) {
            switch (self.Utils.GetCurrentSubTabName()) {
                case subTabNameSqlLinesAgg:
                    {
                        self.changePageSqlLinesAgg(flag);
                    }
                case subTabNameSqlLinesAll:
                    {
                        self.changePageSqlLinesAll(flag);
                    }
                case subTabNameSqlTablesAgg:
                    {
                        self.changePageSqlTablesAgg(flag);
                    }
                case subTabNameSqlTablesAll:
                    {
                        self.changePageSqlTablesAll(flag);
                    }
                case subTabNameXppAgg:
                    {
                        self.changePageXppAgg(flag);
                    }
                case subTabNameXppAll:
                    {
                        self.changePageXppAll(flag);
                    }
            }

            self.updatePageAndRowCounts();
        };

        self.LoadPreviousCallstack = function () {
            if (self.multipleCallStacks()) {
                if (self.currentCallStackIndex() > 1) {
                    self.currentCallStackIndex(self.currentCallStackIndex() - 1, true);
                    self.currentCallStackArrayVisual(allCallStacks[self.currentCallStackIndex() - 1]);
                    self.updateCallStackInclusiveDuration(self.currentCallStackIndex() - 1);
                }
            }
        };
        self.LoadNextCallstack = function () {
            if (self.multipleCallStacks()) {
                if (self.currentCallStackIndex() + 1 <= allCallStacks.length) {
                    self.currentCallStackIndex(self.currentCallStackIndex() + 1, true);
                    self.currentCallStackArrayVisual(allCallStacks[self.currentCallStackIndex() - 1]);
                    self.updateCallStackInclusiveDuration(self.currentCallStackIndex() - 1);
                }
            }
        };

        self.currentCallStackIndex.valueChanged.subscribe(function () {
            self.callStackIndexDescription($dyn.format("{0} / {1}", self.currentCallStackIndex(), callStackItemsCount));
        });

        self.LoadNextPage = function () {
            self.changePage(true);
        };
        self.LoadPreviousPage = function () {
            self.changePage(false);
        };

        //Utility methods

        self.getTraceIdFromQueryString = function () {
            var tempTraceId = parseInt(unescape(("" + document.location.search).substring(1)));
            self.selectedTraceId(tempTraceId, true);
            self.getTraces();
        };

        function round(num) {
            return (Math.round(num * 100)) / 100;
        }

        //Operation methods
        self.startTrace = function () {
            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/StartTrace",
                type: "GET",
                dataType: "text"
            }).done(function (data) {
                if (data) self.ServerVal("Trace Started");
            }).fail(function () {
                self.ServerVal("Beep. Not working");
            });
            self.ShowStartTrace(false);
        };
        self.stopTrace = function () {
            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/StopTrace",
                type: "GET",
                dataType: "text"
            }).done(function (data) {
                if (data) self.ServerVal("Trace Captured");
            }).fail(function () {
                self.ServerVal("Error capturing Trace");
            });
            self.ShowStartTrace(true);
        };
        self.importTrace = function () {
            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/ImportTrace",
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                sessionData = [];
                for (var i = 0; i < data.length; i++) {
                    sessionData.push({ Label: data[i].Username, Value: data[i].Id });
                }

                self.traceSessions(sessionData);
                self.CanLaunch(true);
            }).fail(function (request, error) {
                self.ServerVal("Error Importing");
                $dyn.error({ Message: $dyn.label(error), Label: 'importTrace error' });
            });

        };
        self.getTraces = function () {
            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetTraces",
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                traces = [];
                for (var i = 0; i < data.length; i++) {
                    traces.push({
                        AxVersion: data[i].AxVersion,
                        Description: data[i].Description,
                        TraceFile: data[i].TraceFile.replace(/^.*[\\\/]/, ""),
                        TraceName: data[i].TraceName,
                        TimeStampBegin: new Date(parseInt(data[i].TimeStampBegin.substr(6))).toISOString(),
                        TimeStampEnd: new Date(parseInt(data[i].TimeStampEnd.substr(6))).toISOString(),
                        TraceId: data[i].TraceId,
                        parent: {
                            pageIndex: i,
                            clientPageIndex: Math.ceil(i / self.defaultPageSize),
                            IsLastPage: (data.length - i) > self.defaultPageSize
                        }
                    });
                    
                    if (data[i].TraceId == parseInt(self.selectedTraceId().toString())) {
                        self.selectedTraceGridIndex(i);
                    }
                    
                }

                self.allTraces(traces);
            }).fail(function () {
            });
        };

        self.getStackTraceCount = function (hash, sequence) {
            var params = self.selectedTraceId().toString().concat("/", hash.toString(), "/", self.selectedTraceSession(), "/", self.Utils.GetCurrentSubTabName());
            var urlString = "Services/TraceParserService/service.svc/GetXppAggregatedCallStackInfo/";

            switch (self.Utils.GetCurrentSubTabName()) {
                case subTabNameSqlLinesAgg:
                    urlString = "Services/TraceParserService/service.svc/GetSqlLinesAggregateCallStackInfo/";
                    break;
                case subTabNameSqlTablesAgg:
                    urlString = "Services/TraceParserService/service.svc/GetSqlTablesAggregateCallStackInfo/";
                    break;
                case subTabNameXppAgg:
                    urlString = "Services/TraceParserService/service.svc/GetXppAggregatedCallStackInfo/";
                    break;
                case subTabNameSqlTablesAll:
                case subTabNameSqlLinesAll:
                case subTabNameXppAll:
                    if (sequence) {
                        params = self.selectedTraceId().toString().concat("/", sequence.toString(), "/", self.selectedTraceSession(), "/", self.Utils.GetCurrentSubTabName());
                        urlString = "Services/TraceParserService/service.svc/GetXppNonAggregatedCallStackInfo/";
                    }
                    break;
            }

            self.Utils.CallServer({
                url: urlString + params,
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                if (data && data instanceof Array) {
                    allCallStacksInfo = data.slice();
                    self.updateCallStackInclusiveDuration(0, true);
                    callStackItemsCount = allCallStacksInfo.length;
                }
            }).fail(function () {
            });
        };

        self.updateCallStackInclusiveDuration = function (index) {
            if (allCallStacksInfo[index] && allCallStacksInfo[index].InclusiveMilliseconds) {
                self.totalInclusive($dyn.format('{0}', allCallStacksInfo[index].InclusiveMilliseconds));
            } else {
                self.totalInclusive($dyn.format("Inclusive duration not found"));
            }
        };
        self.getCallStack = function (selection) {
            var selected;
            if (selection) {
                selected = selection[0];
            } else {
                var currentObservable = self.Utils.GetActiveFormObservableBuffered();
                selected = currentObservable()[self.selectedDataGridId()];
            }
            if (selected) {
                var hash = selected.Hash ? selected.Hash : 0;
                var sequence = selected.Sequence ? selected.Sequence : 0;
                var params = self.selectedTraceId().toString().concat("/", hash.toString(), "/", self.selectedTraceSession());
                var urlString = "";
                self.getStackTraceCount(hash, sequence);
                switch (self.Utils.GetCurrentSubTabName()) {
                    case subTabNameSqlLinesAgg:
                        urlString = "Services/TraceParserService/service.svc/GetSqlLinesAggregateCallStack/";
                        break;
                    case subTabNameSqlTablesAgg:
                        urlString = "Services/TraceParserService/service.svc/GetSqlTablesAggregateCallStack/";
                        break;
                    case subTabNameXppAgg:
                        urlString = "Services/TraceParserService/service.svc/GetXppAggregateCallStack/";
                        break;
                    case subTabNameSqlTablesAll:
                    case subTabNameSqlLinesAll:
                    case subTabNameXppAll:
                        params = self.selectedTraceId().toString().concat("/", sequence.toString(), "/", self.selectedTraceSession(), "/", self.Utils.GetCurrentSubTabName());
                        urlString = "Services/TraceParserService/service.svc/GetNonAggregateCallStack/";
                        break;
                    case undefined:
                        params = self.selectedTraceId().toString().concat("/", sequence.toString(), "/", self.selectedTraceSession(), "/", "XppAll");
                        urlString = "Services/TraceParserService/service.svc/GetNonAggregateCallStack/";
                }
                self.Utils.CallServer({
                    url: urlString + params,
                    type: "GET",
                    dataType: "json",
                    statusCode: {
                        400: function () {
                            $dyn.warn({ Message: $dyn.label("Unable to get the call stack for the selected item"), Label: "Unable to get the call stack for the selected item" });
                        }
                    }
                }).done(function (data) {
                    self.populateCallStacks(data);
                }).fail(function () {
                });
            }
        };

        self.populateCallStacks = function (data) {
            allCallStacks = [];
            for (var i = 0; i < data.length; i++) {
                allCallStacks[i] = [];
                for (var j = 0; j < data[i].length; j++) {
                    var parsedCallStack = {
                        Index: j,
                        Name: data[i][j].Name,
                        TraceLineId: data[i][j].TraceLineId
                    };

                    allCallStacks[i].push(parsedCallStack);
                }
            }

            if (allCallStacks.length > 0) {
                self.currentCallStackArrayVisual(allCallStacks[0]);
            }

            if (allCallStacks.length > 1) {
                self.multipleCallStacks(true);
            } else {
                self.multipleCallStacks(false);
            }

            callStackItemsCount = allCallStacks.length;
            self.currentCallStackIndex(1, true);
            self.traceParserCallStackExpanded(true);
        };

        self.updateSouceCode = function () {
            var currentCallStackSelectedRowIndex = self.selectedCallStackIndex();
            var waitString = "";
            var sourceCode = { Text: waitString };
            self.currentSourceCode(sourceCode);
            if (self.currentCallStackArrayVisual == null) {
                return;
            }

            var selected = self.currentCallStackArrayVisual()[currentCallStackSelectedRowIndex];
            if (selected == null) {
                return;
            }

            var tracelineid = selected.TraceLineId;
            if (tracelineid == null) {
                return;
            }

            var params = tracelineid.toString();
            self.currentSourceCode("Fetching source code...");
            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetSourceCode/" + params,
                type: "GET",
                dataType: "json"
            }).done(function (returnedData) {
                sourceCode.Text = returnedData;
                self.currentSourceCode(returnedData);
            }).fail(function (request, error) {
                sourceCode.Text = $dyn.format("Unable to retrieve source code. Error: {0}", error);
                self.currentSourceCode(sourceCode.Text);
            });
        };

        self.openTrace = function () {
            if (self.selectedTraceId() > 0) {
                self.Utils.CallServer({
                    url: "Services/TraceParserService/service.svc/GetSessionSummaries/" + self.selectedTraceId(),
                    type: "GET",
                    dataType: "json",
                    statusCode: {
                        404: function () {
                            $dyn.error({ Message: msgTraceParserErrorTraceNotFound, Label: msgTraceParserErrorTraceNotFound }, this);
                        },
                        406: function () {
                            $dyn.error({ Message: msgTraceParserErrorSessionsNotFound, Label: msgTraceParserErrorSessionsNotFound }, this);
                        },
                        204: function () {
                            $dyn.error({ Message: msgTraceParserErrorSessionsNotFound, Label: msgTraceParserErrorSessionsNotFound }, this);
                        }
                    }
                }).done(function (data) {
                    if (data != null) {
                        sessionData = [];
                        for (var i = 0; i < data.length; i++) {
                            var customerId = data[i].CustomerId;
                            var userName = data[i].Username;
                            var sessionName = data[i].Sessionname;
                            customerId = customerId ? customerId : emptyString;
                            userName = userName ? userName : emptyString;
                            sessionName = sessionName ? sessionName : emptyString;
                            sessionData.push({
                                Customer: customerId,
                                User: userName,
                                Session: sessionName,
                                Value: data[i].Id,
                                XppAggregateInclusiveDuration: data[i].XppAggregateInclusiveDuration,
                                XppAggregateExclusiveDuration: data[i].XppAggregateExclusiveDuration,
                                SqlAggregateTime: data[i].SqlAggregateTime,
                                Duration: data[i].Duration
                            });
                        }

                        self.traceSessions(sessionData);
                        self.selectedTraceSession(0, true);
                        self.CanLaunch(true);
                        self.getData();
                        self.ServerVal("Ready to Launch");
                    } else {
                        $dyn.error({ Message: self.TraceParser_Error_SessionsNotFound, Label: self.TraceParser_Error_SessionsNotFound }, this);
                    }
                }).fail(function () {
                    $dyn.error({ Message: $dyn.label("Error opening trace"), Label: "Error opening trace" }, this);
                });
            }
        };

        self.getData = function () {
            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetXppAvg/" + self.selectedTraceId() + "/" + self.selectedTraceSession(),
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                var tempArr = [];
                for (var i = 0; i < data.length; i++) {
                    tempArr.push({
                        Name: data[i].Name,
                        Count: data[i].Count,
                        Inclusive_Total: round(data[i].InclusiveTotal),
                        Inclusive_Average: round(data[i].InclusiveAvg),
                        Exclusive_Total: round(data[i].ExclusiveTotal),
                        Exclusive_Average: round(data[i].ExclusiveAvg),
                        Total_Database_Calls: round(data[i].DatabaseCallsTotal),
                        Average_Database_Calls: round(data[i].DatabaseCallsAvg),
                        Database: round(data[i].DatabaseMilliseconds),
                        Hash: data[i].Hash.toString(),
                        parent: {
                            pageIndex: i,
                            clientPageIndex: Math.ceil(i / self.defaultPageSize),
                            IsLastPage: (data.length - i) > self.defaultPageSize
                        }
                    });
                }

                self.xppAggDataFull(tempArr);
                self.ServerVal("Got XPP Avg");
            }).fail(function () {
                self.ServerVal("Error getting xpp data");
            });


            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetXpp/" + self.selectedTraceId() + "/" + self.selectedTraceSession(),
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                var xppAllDataFullTemp = [];
                for (var i = 0; i < data.length; i++) {
                    xppAllDataFullTemp.push({
                        Name: data[i].Name,
                        InclusiveMilliseconds: round(data[i].InclusiveMilliseconds),
                        ExclusiveMilliseconds: round(data[i].ExclusiveMilliseconds),
                        DatabaseCalls: round(data[i].DatabaseCalls),
                        DatabaseMilliseconds: round(data[i].DatabaseMilliseconds),
                        Sequence: data[i].Sequence,
                        SequenceEnd: data[i].SequenceEnd,
                        ParentSequence: data[i].ParentSequence,
                        Hash: data[i].Hash,
                        parent: {
                            pageIndex: i + 1,
                            clientPageIndex: Math.ceil((i + 1) / self.defaultPageSize),
                            IsLastPage: (data.length - i - 1) > self.defaultPageSize
                        }
                    });
                }

                self.xppAllDataFull(xppAllDataFullTemp);
                self.ServerVal("Got Xpp");
            }).fail(function () {
                self.ServerVal("Error getting xpp data");
            });

            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetSqlLines/" + self.selectedTraceId() + "/" + self.selectedTraceSession(),
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                var tempArr = [];
                for (var i = 0; i < data.length; i++) {
                    tempArr.push({
                        Name: data[i].Name,
                        InclusiveMilliseconds: round(data[i].InclusiveMilliseconds),
                        ExclusiveMilliseconds: round(data[i].ExclusiveMilliseconds),
                        PrepDurationMilliseconds: round(data[i].PrepDurationMilliseconds),
                        BindDurationMilliseconds: round(data[i].BindDurationMilliseconds),
                        RowFetchDurationMilliseconds: round(data[i].RowFetchDurationMilliseconds),
                        RowFetchCount: round(data[i].RowFetchCount),
                        ExecutionTime: round(data[i].ExecutionTime),
                        Sequence: round(data[i].Sequence),
                        SequenceEnd: data[i].SequenceEnd,
                        ParentSequence: data[i].ParentSequence,
                        parent: {
                            pageIndex: i,
                            clientPageIndex: Math.ceil(i / self.defaultPageSize),
                            IsLastPage: (data.length - i) > self.defaultPageSize
                        }
                    });
                }

                self.sqlAllLinesDataFull(tempArr);
                self.ServerVal("Got SQL");
            }).fail(function () {
                self.ServerVal("Error getting sql data");
            });

            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetSqlTables/" + self.selectedTraceId() + "/" + self.selectedTraceSession(),
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                var tempArr = [];
                for (var i = 0; i < data.length; i++) {
                    tempArr.push({
                        Name: data[i].Name,
                        InclusiveMilliseconds: round(data[i].InclusiveMilliseconds),
                        ExclusiveMilliseconds: round(data[i].ExclusiveMilliseconds),
                        PrepDurationMilliseconds: round(data[i].PrepDurationMilliseconds),
                        BindDurationMilliseconds: round(data[i].BindDurationMilliseconds),
                        RowFetchDurationMilliseconds: round(data[i].RowFetchDurationMilliseconds),
                        RowFetchCount: round(data[i].RowFetchCount),
                        ExecutionTime: round(data[i].ExecutionTime),
                        Sequence: round(data[i].Sequence),
                        parent: {
                            pageIndex: i,
                            clientPageIndex: Math.ceil(i / self.defaultPageSize),
                            IsLastPage: (data.length - i) > self.defaultPageSize
                        }
                    });
                }

                self.sqlAllTablesDataFull(tempArr);
                self.ServerVal("Got SQL");
            }).fail(function () {
                self.ServerVal("Error getting sql data");
            });

            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetSqlLinesAggregate/" + self.selectedTraceId() + "/" + self.selectedTraceSession(),
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                var tempArr = [];
                for (var i = 0; i < data.length; i++) {
                    tempArr.push({
                        Name: data[i].Name,
                        Count: data[i].Count,
                        Inclusive_Total: round(data[i].InclusiveTotal),
                        Inclusive_Avg: round(data[i].InclusiveAvg),
                        Exclusive_Total: round(data[i].ExclusiveTotal),
                        Exclusive_Avg: round(data[i].ExclusiveAvg),
                        RowFetch_Total: round(data[i].RowFetchTotal),
                        RowFetchCount: round(data[i].RowFetchCountTotal),
                        ExecutionTime: round(data[i].TotalExecutionTime),
                        Hash: data[i].Hash.toString(),
                        parent: {
                            pageIndex: i,
                            clientPageIndex: Math.ceil(i / self.defaultPageSize),
                            IsLastPage: (data.length - i) > self.defaultPageSize
                        }
                    });
                }

                self.sqlAggLinesFull(tempArr);
                self.ServerVal("Got SQL");
            }).fail(function () {
                self.ServerVal("Error getting sql data");
            });

            self.Utils.CallServer({
                url: "Services/TraceParserService/service.svc/GetSqlTablesAggregate/" + self.selectedTraceId() + "/" + self.selectedTraceSession(),
                type: "GET",
                dataType: "json"
            }).done(function (data) {
                var tempArr = [];
                for (var i = 0; i < data.length; i++) {
                    tempArr.push({
                        Name: data[i].Name,
                        Count: data[i].Count,
                        Inclusive_Total: round(data[i].InclusiveTotal),
                        Inclusive_Avg: round(data[i].InclusiveAvg),
                        Exclusive_Total: round(data[i].ExclusiveTotal),
                        Exclusive_Avg: round(data[i].ExclusiveAvg),
                        RowFetch_Total: round(data[i].RowFetchTotal),
                        RowFetchCount: round(data[i].RowFetchCountTotal),
                        ExecutionTime: round(data[i].TotalExecutionTime),
                        Hash: data[i].Hash.toString(),
                        parent: {
                            pageIndex: i,
                            clientPageIndex: Math.ceil(i / self.defaultPageSize),
                            IsLastPage: (data.length - i) > self.defaultPageSize
                        }
                    });
                }

                self.sqlAggTablesFull(tempArr);
                self.ServerVal("Got SQL");
            }).fail(function () {
                self.ServerVal("Error getting sql data");
            });
        }; //Init the form, load the data
        self.getTraceIdFromQueryString();
        self.openTrace();

        //Runtime code for the treeGrid
        self.treeGridDataSourceLocalArray = $dyn.observableArray();

        self.treeGridSource =
        {
            dataType: "json",
            dataFields: [
                { name: "Name", type: "string" },
                { name: "InclusiveMilliseconds", type: "number" },
                { name: "ExclusiveMilliseconds", type: "number" },
                { name: "DatabaseCalls", type: "number" },
                { name: "CallTypeId", type: "number" },
                { name: "DatabaseMilliseconds", type: "number" },
                { name: "LayerId", type: "number" },
                { name: "Sequence", type: "number" },
                { name: "SequenceEnd", type: "number" },
                { name: "ParentSequence", type: "number" }
            ],
            timeout: 10000,
            hierarchy:
            {
                keyDataField: { name: "Sequence" },
                parentDataField: { name: "ParentSequence" }
            },
            id: "Sequence",
            localData: self.treeGridDataSourceLocalArray
        };

        // ReSharper disable once InconsistentNaming
        self.treeGridDataAdapter = new $.jqx.dataAdapter(self.treeGridSource);
        self.refreshTreeGrid = function () {
            self.treeGridDataSourceLocalArray(self.xppAllDataFull().concat(self.sqlAllLinesDataFull()));
            $("#treeGrid").jqxTreeGrid('updateBoundData');
        };

        self.xppAllDataFull.valueChanged.subscribe(function () {
            self.refreshTreeGrid();
        });

        self.sqlAllLinesDataFull.valueChanged.subscribe(function () {
            self.refreshTreeGrid();
        });

        self.loadTreeGrid = function () {

            // create Tree Grid
            $("#treeGrid").jqxTreeGrid(
            {
                columnsResize: true,
                sortable: true,
                filterable: true,
                filterMode: "advanced",
                source: self.treeGridDataAdapter,
                columns: [
                    { text: "Name", dataField: "Name", width: 400 },
                    { text: "InclusiveMs", dataField: "InclusiveMilliseconds", width: 100 },
                    { text: "ExclusiveMs", dataField: "ExclusiveMilliseconds", width: 100 },
                    { text: "DatabaseCalls", dataField: "DatabaseCalls", width: 100 },
                    { text: "DatabaseMs", dataField: "DatabaseMilliseconds", width: 100 }
                ]
            });
        };

        self.loadTreeGrid();

        self.createSubTrace = function () {
            var selectedRow = $("#treeGrid").jqxTreeGrid("getSelection");
            var selection;
            if (selectedRow[0]) {
                //Get the first selected row
                selection = selectedRow[0];

                if (selection && selection.Sequence) {
                    var currentSession = self.traceSessions()[self.selectedTraceSession()];
                    if (currentSession) {
                        var customerId = currentSession.Customer ? currentSession.Customer : "";
                        var userName = currentSession.User ? currentSession.User : "";
                        var sessionName = currentSession.Session ? currentSession.Session : "";
                        var sequenceBegin = selection.Sequence;
                        var sequenceEnd = selection.SequenceEnd;

                        var csrfTokenValue = "";
                        var tokenSearchKey = 'ms-dyn-csrftoken' + "=";
                        var cookies = document.cookie.split(";");
                        for (var i = 0; i < cookies.length; i++) {
                            var kvp = cookies[i].trim();
                            if (kvp.indexOf(tokenSearchKey) == 0) {
                                csrfTokenValue = kvp.substr(tokenSearchKey.length);
                            }
                        }

                        self.Utils.CallServer({
                            url: "Services/TraceParserService/service.svc/CreateSubtrace",
                            type: "POST",
                            dataType: "json",
                            headers: {
                                "CustomerId": customerId,
                                "Username": userName,
                                "Sessionname": sessionName,
                                "SequenceBegin": sequenceBegin,
                                "SequenceEnd": sequenceEnd,
                                "TraceId": self.selectedTraceId(),
                                "ms-dyn-csrftoken": csrfTokenValue
                            },
                            statusCode: {
                                400: function () {
                                    $dyn.error({ Message: $dyn.label(msgGenericError), Label: msgGenericError });
                                },
                                500: function () {
                                    $dyn.warn({ Message: $dyn.label(msgCantCreateSubtrace), Label: msgCantCreateSubtrace });
                                }
                            },
                            processData: false
                        }).done(function (data) {
                            if (data) {
                                var parsedData = parseInt(data);
                                if (parsedData > 0) {
                                    self.selectedTraceId(parsedData);
                                    self.openTrace();
                                }

                                self.getTraces();
                                self.showXppAgg(true);
                                self.ActiveItemName($dyn.label("TraceParser_TabXpp"));
                            }
                        });
                    }
                }
            }
        };

        self.Refresh = function () {
            $("#treeGrid").jqxTreeGrid('render');
        };

        self.JumpToCallTree = function () {
            var currentObservable = self.Utils.GetActiveFormObservableBuffered();
            var selection = currentObservable()[self.selectedDataGridId()];
            if (selection && selection.Sequence) {
                self.ActiveItemName($dyn.label("TraceParser_TabCallTree"));
                var filtertype = "stringfilter";
                var filtergroup = new $.jqx.filter();
                var filterOrOperator = 1;
                var filtervalue = selection.Name;
                var filtercondition = "equal";
                var filter = filtergroup.createfilter(filtertype, filtervalue, filtercondition);
                filtergroup.addfilter(filterOrOperator, filter);
                $("#treeGrid").jqxTreeGrid("addFilter", "Name", filtergroup);
                $("#treeGrid").jqxTreeGrid("applyFilters");
                var firstLevelRows = $("#treeGrid").jqxTreeGrid("getRows");
                self.NavigateToJqTreeGridRow(selection.Sequence, firstLevelRows);
            } else {
                $dyn.warn({ Message: $dyn.label("Can't jump from aggregated view."), Label: "Can't jump from aggregated view." } );
            }
        };

        self.NavigateToJqTreeGridRow = function (sequence, getCurrentLevelRows) {
            if (sequence && getCurrentLevelRows && getCurrentLevelRows.length > 0) {
                // ReSharper disable once JsUnreachableCode
                for (var i = 0; i < getCurrentLevelRows.length; i++) {
                    var rowData = getCurrentLevelRows[i];
                    if (rowData.Sequence == sequence) {
                        $("#treeGrid").jqxTreeGrid("selectRow", sequence);
                        break;
                    }

                    if (rowData.Sequence < sequence && rowData.SequenceEnd > sequence) {
                        while (rowData.Sequence !== sequence) {
                            $("#treeGrid").jqxTreeGrid("expandRow", rowData.Sequence);
                            self.NavigateToJqTreeGridRow(sequence, rowData.records);
                            break;
                        }

                    } else {
                        continue;
                    }
                }
            }
        };
        self.ExpandRow = function () {
            var selection = $("#treeGrid").jqxTreeGrid("getSelection");
            self.traverseRows(selection, 10);
        };
        self.traverseRows = function traverseRows(rows, recursionLimit) {
            if (recursionLimit === 0) {
                return;
            }

            var sequence;
            var i = 0;
            if ($.isArray(rows) && rows.length > 0) {
                if (rows[i].records) {
                    sequence = rows[i].Sequence;
                    $("#treeGrid").jqxTreeGrid("expandRow", sequence);
                    traverseRows(rows[i].records, recursionLimit - 1);
                }
            }
        };

        self.JumpToTab = function (tabName) {
            var selection = $("#treeGrid").jqxTreeGrid("getSelection");
            self.ActiveItemName(tabName);
            for (var i = 0; i < selection.length; i++) {
                var rowData = selection[i];
                self.inputFilterVal(rowData.Name);
                self.applyFilterValue();
            }
        };
        self.JumpToXpp = function () {
            self.showXppAgg(false);
            self.JumpToTab($dyn.label("TraceParser_TabXpp"));
        };
        self.JumpToSql = function () {
            self.sqlAvg(false);
            self.JumpToTab($dyn.label("TraceParser_TabSql"));
        };
    };

    window.traceParser = _traceParser;
})(window.traceParser || {});